import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable( { providedIn: 'root' } )
export class TooltipMessageService {
    private addressTooltipSource = new BehaviorSubject<string>("default message");
    private nameMessageSource = new BehaviorSubject<string>("default message");
    private disableHeaderSource = new BehaviorSubject<boolean>(false);
    private disableNavBarSource = new BehaviorSubject<boolean>(false);
    private unsortListSource = new BehaviorSubject<typeof event>(event);
    private isDobValidSource = new BehaviorSubject<boolean>(false);
    private hasLostSession = new BehaviorSubject<boolean>(true);

    currentAddressTooltip = this.addressTooltipSource.asObservable();
    currentNameMessage = this.nameMessageSource.asObservable();
    currentDisableHeader = this.disableHeaderSource.asObservable();
    currentUnsortList = this.unsortListSource.asObservable();
    currentDisableNavBar = this.disableNavBarSource.asObservable();
    currentDisableDobValid = this.isDobValidSource.asObservable();
    userLostSession = this.hasLostSession.asObservable();

    constructor() {}

    changeTooltip (addressTooltip: string) {
        this.addressTooltipSource.next(addressTooltip)
    }

    changeNameMessage (nameMessage: string) {
        this.nameMessageSource.next(nameMessage)
    }

    disabledHeader (disableHeader: boolean){
        this.disableHeaderSource.next(disableHeader)
    }

    disableNavBar (disableNavBar: boolean){
        this.disableNavBarSource.next(disableNavBar)
    }

    unsortCaseList (unsortList: typeof event){
        this.unsortListSource.next(unsortList)
    }

    hideDobPicker(isDobValid: boolean){
        this.isDobValidSource.next(isDobValid)
    }

    lostSessionStorage(lostSessionStorage: boolean){
        this.hasLostSession.next(lostSessionStorage);
    }

}